<template>
  <div id="test">
    <div class="loginContainer">
      <a class="openApp" :href="app.packageName">開APP</a>
      <br />
      <label>{{ count }}</label>
    </div>

    <div class="loginBackground"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      app: {
        packageName: 'surreal.cms://other/aaaa/here',
      },
      count: 0,
    };
  },
  mounted() {
    this.StartTimer();
  },
  methods: {
    StartTimer() {
      let vuethis = this;
      setInterval(function () {
        vuethis.count++;
      }, 1000);
    },
  },
};
</script>
<style scoped>
.openApp {
  color: #000;
}
.openApp:hover {
  color: #aaaaaa;
}
</style>
<style >
body {
  min-width: 0;
}
</style>
